// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.intake-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f8f8f8;
  position: relative;
}

.intake-page main {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem 2rem;
  min-height: calc(100vh - 80px);
  height: calc(100vh - 80px);
  position: relative;
  overflow-y: auto;
}

.intake-container {
  width: 100%;
  margin: 0 auto;
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
}

.intake-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  z-index: 1;
}

.intake-wizard {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  padding: 2rem;
  position: relative;
  z-index: 2;
  max-height: calc(100vh - 80px - 4rem);
  overflow-y: auto;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

/* Profile Section */
.wizard-profile {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 2px solid #f0f0f0;
}

.profile-image-container {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  border: 3px solid #ffbb00;
  flex-shrink: 0;
}

.profile-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.profile-info h2 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #000;
  margin: 0 0 0.25rem 0;
}

.profile-info p {
  font-size: 0.9rem;
  color: #666;
  margin: 0;
}

/* Progress Bar */
.progress-bar {
  width: 100%;
  height: 4px;
  background: #f0f0f0;
  border-radius: 2px;
  margin-bottom: 1.5rem;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(135deg, #ffbb00 0%, #cc9900 100%);
  border-radius: 2px;
  transition: width 0.3s ease;
}

/* Question Section */
.question-section {
  min-height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.question-number {
  font-size: 0.85rem;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 0.75rem;
}

.question-title {
  font-size: 2rem;
  font-weight: 900;
  color: #000;
  margin: 0 0 1.25rem 0;
  line-height: 1.2;
}

.question-input {
  width: 100%;
  padding: 1rem 1.25rem;
  font-size: 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  background: #fff;
  color: #000;
  font-family: inherit;
  transition: all 0.3s ease;
  outline: none;
  box-sizing: border-box;
}

.question-input:focus {
  border-color: #ffbb00;
  box-shadow: 0 0 0 3px rgba(255, 187, 0, 0.1);
}

.question-input::placeholder {
  color: #999;
}

textarea.question-input {
  resize: vertical;
  min-height: 120px;
  max-height: 200px;
  font-family: inherit;
}

/* Select Options */
.select-options {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.select-option {
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 0.95rem;
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  background: #fff;
  color: #000;
  text-align: left;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.select-option:hover {
  border-color: #ffbb00;
  background: rgba(255, 187, 0, 0.05);
}

.select-option.selected {
  border-color: #ffbb00;
  background: linear-gradient(135deg, rgba(255, 187, 0, 0.1) 0%, rgba(255, 187, 0, 0.05) 100%);
  color: #000;
  font-weight: 600;
}

/* Error Message */
.error-message {
  margin-top: 1rem;
  padding: 1rem;
  background: #fee;
  border: 2px solid #fcc;
  border-radius: 8px;
  color: #c00;
  font-size: 0.95rem;
}

/* reCAPTCHA */
.recaptcha-container {
  margin: 1rem 0;
  display: flex;
  justify-content: center;
  transform: scale(0.85);
  transform-origin: center;
}

/* Wizard Actions */
.wizard-actions {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1rem;
  padding-top: 1.25rem;
  border-top: 2px solid #f0f0f0;
}

.wizard-actions .btn {
  flex: 1;
  padding: 0.875rem 1.5rem;
  font-size: 1rem;
  font-weight: 700;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
  text-align: center;
}

.wizard-actions .btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.wizard-actions .btn-primary {
  background: linear-gradient(135deg, #ffbb00 0%, #cc9900 100%);
  color: #000;
}

.wizard-actions .btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 187, 0, 0.4);
}

.wizard-actions .btn-secondary {
  background: #f0f0f0;
  color: #333;
}

.wizard-actions .btn-secondary:hover {
  background: #e0e0e0;
}

/* Success Message */
.success-message {
  text-align: center;
  padding: 4rem 2rem;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  z-index: 3;
}

.success-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffbb00 0%, #cc9900 100%);
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
  font-weight: 900;
  margin: 0 auto 2rem;
}

.success-message h1 {
  font-size: 2.5rem;
  font-weight: 900;
  color: #000;
  margin: 0 0 1rem 0;
}

.success-message p {
  font-size: 1.2rem;
  color: #666;
  margin: 0 0 2rem 0;
}

/* Optimize for 1080px height screens */
@media (min-height: 1000px) and (max-height: 1080px) {
  .intake-page main {
    padding: 1rem 2rem;
    height: calc(100vh - 80px);
    min-height: calc(100vh - 80px);
  }

  .intake-wizard {
    padding: 1.5rem;
    max-height: calc(100vh - 80px - 3rem);
  }

  .wizard-profile {
    margin-bottom: 1rem;
    padding-bottom: 1rem;
  }

  .progress-bar {
    margin-bottom: 1rem;
  }

  .question-title {
    font-size: 1.75rem;
    margin-bottom: 1rem;
  }

  .question-input {
    padding: 0.875rem 1rem;
  }

  textarea.question-input {
    min-height: 100px;
    max-height: 180px;
  }

  .select-options {
    gap: 0.4rem;
  }

  .select-option {
    padding: 0.65rem 0.875rem;
    font-size: 0.9rem;
  }

  .recaptcha-container {
    margin: 1rem 0;
    transform: scale(0.85);
  }

  .wizard-actions {
    margin-top: 1rem;
    padding-top: 1rem;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .intake-page main {
    padding: 2rem 1rem;
  }

  .intake-wizard {
    padding: 2rem 1.5rem;
  }

  .wizard-profile {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .profile-image-container {
    width: 100px;
    height: 100px;
  }

  .question-title {
    font-size: 2rem;
  }

  .question-input {
    font-size: 1rem;
    padding: 1rem 1.25rem;
  }

  .select-option {
    font-size: 1rem;
    padding: 1rem 1.25rem;
  }

  .wizard-actions {
    flex-direction: column;
  }

  .wizard-actions .btn {
    width: 100%;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/intake/IntakeForm.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,qCAAqC;EACrC,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,4FAA4F;EAC5F,WAAW;EACX,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".intake-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: #f8f8f8;\n  position: relative;\n}\n\n.intake-page main {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem 2rem;\n  min-height: calc(100vh - 80px);\n  height: calc(100vh - 80px);\n  position: relative;\n  overflow-y: auto;\n}\n\n.intake-container {\n  width: 100%;\n  margin: 0 auto;\n  position: relative;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  overflow: hidden;\n}\n\n.intake-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.75);\n  z-index: 1;\n}\n\n.intake-wizard {\n  background: rgba(255, 255, 255, 0.98);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n  padding: 2rem;\n  position: relative;\n  z-index: 2;\n  max-height: calc(100vh - 80px - 4rem);\n  overflow-y: auto;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n/* Profile Section */\n.wizard-profile {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  margin-bottom: 1.5rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 2px solid #f0f0f0;\n}\n\n.profile-image-container {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  overflow: hidden;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);\n  border: 3px solid #ffbb00;\n  flex-shrink: 0;\n}\n\n.profile-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.profile-info h2 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #000;\n  margin: 0 0 0.25rem 0;\n}\n\n.profile-info p {\n  font-size: 0.9rem;\n  color: #666;\n  margin: 0;\n}\n\n/* Progress Bar */\n.progress-bar {\n  width: 100%;\n  height: 4px;\n  background: #f0f0f0;\n  border-radius: 2px;\n  margin-bottom: 1.5rem;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(135deg, #ffbb00 0%, #cc9900 100%);\n  border-radius: 2px;\n  transition: width 0.3s ease;\n}\n\n/* Question Section */\n.question-section {\n  min-height: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.question-number {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #666;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 0.75rem;\n}\n\n.question-title {\n  font-size: 2rem;\n  font-weight: 900;\n  color: #000;\n  margin: 0 0 1.25rem 0;\n  line-height: 1.2;\n}\n\n.question-input {\n  width: 100%;\n  padding: 1rem 1.25rem;\n  font-size: 1rem;\n  border: 2px solid #e0e0e0;\n  border-radius: 12px;\n  background: #fff;\n  color: #000;\n  font-family: inherit;\n  transition: all 0.3s ease;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.question-input:focus {\n  border-color: #ffbb00;\n  box-shadow: 0 0 0 3px rgba(255, 187, 0, 0.1);\n}\n\n.question-input::placeholder {\n  color: #999;\n}\n\ntextarea.question-input {\n  resize: vertical;\n  min-height: 120px;\n  max-height: 200px;\n  font-family: inherit;\n}\n\n/* Select Options */\n.select-options {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.select-option {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  font-size: 0.95rem;\n  border: 2px solid #e0e0e0;\n  border-radius: 10px;\n  background: #fff;\n  color: #000;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: inherit;\n}\n\n.select-option:hover {\n  border-color: #ffbb00;\n  background: rgba(255, 187, 0, 0.05);\n}\n\n.select-option.selected {\n  border-color: #ffbb00;\n  background: linear-gradient(135deg, rgba(255, 187, 0, 0.1) 0%, rgba(255, 187, 0, 0.05) 100%);\n  color: #000;\n  font-weight: 600;\n}\n\n/* Error Message */\n.error-message {\n  margin-top: 1rem;\n  padding: 1rem;\n  background: #fee;\n  border: 2px solid #fcc;\n  border-radius: 8px;\n  color: #c00;\n  font-size: 0.95rem;\n}\n\n/* reCAPTCHA */\n.recaptcha-container {\n  margin: 1rem 0;\n  display: flex;\n  justify-content: center;\n  transform: scale(0.85);\n  transform-origin: center;\n}\n\n/* Wizard Actions */\n.wizard-actions {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-top: 1rem;\n  padding-top: 1.25rem;\n  border-top: 2px solid #f0f0f0;\n}\n\n.wizard-actions .btn {\n  flex: 1;\n  padding: 0.875rem 1.5rem;\n  font-size: 1rem;\n  font-weight: 700;\n  border-radius: 12px;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  display: inline-block;\n  text-align: center;\n}\n\n.wizard-actions .btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.wizard-actions .btn-primary {\n  background: linear-gradient(135deg, #ffbb00 0%, #cc9900 100%);\n  color: #000;\n}\n\n.wizard-actions .btn-primary:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(255, 187, 0, 0.4);\n}\n\n.wizard-actions .btn-secondary {\n  background: #f0f0f0;\n  color: #333;\n}\n\n.wizard-actions .btn-secondary:hover {\n  background: #e0e0e0;\n}\n\n/* Success Message */\n.success-message {\n  text-align: center;\n  padding: 4rem 2rem;\n  background: rgba(255, 255, 255, 0.98);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  position: relative;\n  z-index: 3;\n}\n\n.success-icon {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #ffbb00 0%, #cc9900 100%);\n  color: #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 3rem;\n  font-weight: 900;\n  margin: 0 auto 2rem;\n}\n\n.success-message h1 {\n  font-size: 2.5rem;\n  font-weight: 900;\n  color: #000;\n  margin: 0 0 1rem 0;\n}\n\n.success-message p {\n  font-size: 1.2rem;\n  color: #666;\n  margin: 0 0 2rem 0;\n}\n\n/* Optimize for 1080px height screens */\n@media (min-height: 1000px) and (max-height: 1080px) {\n  .intake-page main {\n    padding: 1rem 2rem;\n    height: calc(100vh - 80px);\n    min-height: calc(100vh - 80px);\n  }\n\n  .intake-wizard {\n    padding: 1.5rem;\n    max-height: calc(100vh - 80px - 3rem);\n  }\n\n  .wizard-profile {\n    margin-bottom: 1rem;\n    padding-bottom: 1rem;\n  }\n\n  .progress-bar {\n    margin-bottom: 1rem;\n  }\n\n  .question-title {\n    font-size: 1.75rem;\n    margin-bottom: 1rem;\n  }\n\n  .question-input {\n    padding: 0.875rem 1rem;\n  }\n\n  textarea.question-input {\n    min-height: 100px;\n    max-height: 180px;\n  }\n\n  .select-options {\n    gap: 0.4rem;\n  }\n\n  .select-option {\n    padding: 0.65rem 0.875rem;\n    font-size: 0.9rem;\n  }\n\n  .recaptcha-container {\n    margin: 1rem 0;\n    transform: scale(0.85);\n  }\n\n  .wizard-actions {\n    margin-top: 1rem;\n    padding-top: 1rem;\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .intake-page main {\n    padding: 2rem 1rem;\n  }\n\n  .intake-wizard {\n    padding: 2rem 1.5rem;\n  }\n\n  .wizard-profile {\n    flex-direction: column;\n    text-align: center;\n    gap: 1rem;\n  }\n\n  .profile-image-container {\n    width: 100px;\n    height: 100px;\n  }\n\n  .question-title {\n    font-size: 2rem;\n  }\n\n  .question-input {\n    font-size: 1rem;\n    padding: 1rem 1.25rem;\n  }\n\n  .select-option {\n    font-size: 1rem;\n    padding: 1rem 1.25rem;\n  }\n\n  .wizard-actions {\n    flex-direction: column;\n  }\n\n  .wizard-actions .btn {\n    width: 100%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
